import { AssessmentEvent } from "../scripts/assessments.entities";
import { AssessmentLookup } from "../scripts/assessments.lookup";



export class AssessmentSummarySeries {
    name: string;
    //data: Map<number, number>; //captures both status and completion timing; ID of visit status or timing completion
    type: string;
    typeId: number; //visitId, siteNumber, etc.
    sortValue: number;
    visits: Map<number, AssessmentEvent[]>;
 
    constructor(name: string, type: string, typeId: number) {
        this.name = name;
        //this.data = new Map<number, number>();        
        this.type = type;
        this.typeId = typeId;
        this.sortValue = (type == "visit") ? AssessmentLookup.GetTimepointOrdering(typeId) : (type == "assessment") ? AssessmentLookup.GetAssessmentOrdering(typeId) : typeId = 0;
        this.visits = new Map<number, AssessmentEvent[]>();
    }

    addVisitEvent(event: AssessmentEvent): void {
        if (event.StatusId === 0) {
            console.warn("Event skipped due to StatusId === 0", event);
            return;
        }

        if (!this.visits.has(event.StatusId)) {
            this.visits.set(event.StatusId, []);
        }
        this.visits.get(event.StatusId).push(event);

        if (!this.visits.has(event.percentCompleteId)) {
            this.visits.set(event.percentCompleteId, []);
        }
        this.visits.get(event.percentCompleteId).push(event);

        if (this.type === "site") {
            this.sortValue += 1;
        }
    }
}